import { render, staticRenderFns } from "./previewCertificate.vue?vue&type=template&id=db5f8112&scoped=true"
import script from "./previewCertificate.vue?vue&type=script&lang=js"
export * from "./previewCertificate.vue?vue&type=script&lang=js"
import style0 from "./previewCertificate.vue?vue&type=style&index=0&id=db5f8112&prod&lang=stylus"
import style1 from "./previewCertificate.vue?vue&type=style&index=1&id=db5f8112&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f8112",
  null
  
)

export default component.exports